module.exports = __webpack_public_path__ + "static/media/play-active.29f9ddcf.svg";